import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import { IoCloseSharp } from "react-icons/io5";

interface MenuItem {
    text: string;
    link: string;
}

interface NavLink {
    text: string;
    link: string;
}

interface ContextsItems {
    headerText: string;
    placeholderText: string[];
    accessLinkText: string;
    navigationLinks: NavLink[];
    isMenuOpen: boolean;
}

const HamburgerMenuWindow: React.FC<{ hidden: boolean }> = ({ hidden }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [isActive, setIsActive] = useState<number>(() => {
        try {
            const savedIndex = localStorage.getItem("activeMenuIndex");
            return savedIndex ? parseInt(savedIndex, 10) : 0;
        } catch (error) {
            console.error("Error accessing localStorage:", error);
            return 0;
        }
    });
    useEffect(() => {
        setIsActive(isActive);
    }, []);

    useEffect(() => {
        setIsOpen(!isOpen);
    }, [hidden]);

    useEffect(() => {
        try {
            localStorage.setItem("activeMenuIndex", isActive.toString());
        } catch (error) {
            console.error("Error saving to localStorage:", error);
        }
    }, [isActive]);

    const menuItems: MenuItem[] = [
        { text: "Main Home", link: "/" },
        { text: "About Us", link: "/aboutUs" },
        { text: "Mineralex SL", link: "/exploration" },
        { text: "Tokenization", link: "/tokenization" },
        { text: "Roadmap", link: "/roadmap" },
        { text: "Presale Token", link: "/presale_Token" },
        { text: "Blogs", link: "/blogs" },
        { text: "Contact Us", link: "/contact_Us" },
        { text: "Investor Portal", link: "/investor_Portal" },
    ];

    const contextsItems: ContextsItems[] = [
        {
            headerText: "Home Page",
            placeholderText: [
                "Bridging Mining and Blockchain Technology",
                "Over 20 years of experience in mineral exploration, mining and investment through its subsidiary Mineralex (SL) Limited in Sierra Leone.",
                "Mineralex Group aim to revolutionize mineral exploration and extraction through tokenized operations, enabling widespread investor participation and empowering local African communities.",
                "By combining blockchain’s transparency with the tangible backing of real-world assets, Mineralex aims to create secure, accessible, and profitable mining investment opportunities for global investors.",
            ],
            accessLinkText: "Access the page",
            navigationLinks: [
                { text: "Home", link: "#home" },
                { text: "About Us", link: "#about" },
                { text: "The Mineral market challenges", link: "#market_challenges" },
                { text: "MINERALEX TOKEN STRATEGY", link: "#token_strategy" },
                { text: "The planned Tokens", link: "#plannedTokens" },
                { text: "EXPLORATION", link: "#exploration" },
                { text: "COMMUNITY APPROACH", link: "#community" },
                { text: "QUICK LINKS", link: "#quick-links" },
            ],
            isMenuOpen: isOpen,
        },
        {
            headerText: "What we do?",
            placeholderText: [
                "Mineralex Group specializing in blockchain technology, managing and investing in mineral exploration and mining projects. Mineralex Group poised to leverage over a decade of experience in Sierra Leone's mineral sector through its subsidiary, Mineralex (SL) Limited.",
                "The group's primary objective is to integrate blockchain technology with traditional mining practices, thereby offering global investors accessible, transparent, and flexible investment opportunities in valuable mineral resources.",
                "In response to the escalating global demand for minerals such as gold, coltan, and rare earth metals, Mineralex Group plans to address traditional industry challenges—such as high barriers to entry, unequal profit-sharing mechanisms and lack of transparency—by leveraging blockchain-based tokenization.",
            ],
            accessLinkText: "Read More",
            navigationLinks: [
                { text: "What we do?", link: "#aboutUs" },
                { text: "ABOUT MINERALEX GROUP", link: "#mineralexGroup" },
                { text: "ABOUT MINERALEX (SL)", link: "#mineralex(sl)" },
                { text: "HISTORY", link: "#history" },
                { text: "STAFF AND POLICIES", link: "#staffAndPolicies" },
                { text: "OUR MAIN TEAM", link: "#mainTeam" },
                { text: "Quick Links", link: "#quick-links" },
            ],
            isMenuOpen: isOpen,
        },
        {
            headerText: "Explore Our Resources",
            placeholderText: [
                "Advanced geophysical techniques such as Gradient Array and High-Resolution Induced Polarization (HIRIP) surveys, Fire Assay Analysis, Ultra-Ground Penetrating Radar and more were adopted together with Trenching, Pitting, Drilling and Trial Mining.",
                " These advanced methods have been instrumental in identifying mineral-rich zones deep within the bedrock, thereby guiding targeted exploration efforts for Gold, Coltan, Rare Earth Elements (REE), Tin, and Diamonds. ",
                "The utilization of these advanced techniques underscores the company's commitment to employing cutting-edge technology in its exploration endeavors.",
            ],
            accessLinkText: "Browse Resources",
            navigationLinks: [
                { text: "Exploration & Results", link: "#exploration_Home" },
                { text: "Comprehensive exploration", link: "#presentation" },
                { text: "High-value mineral deposits", link: "#mineral_Deposits" },
                { text: "WORK DONE HIGHLIGHTS", link: "#work_Highlights" },
                { text: "Exploration RESULTS Highlights", link: "#result_Highlights" },
                { text: "FUTURE PLANS", link: "#future_plans" },
                { text: "Quick Links", link: "#quick-links" },
            ],
            isMenuOpen: isOpen,
        },
        {
            headerText: "The Future of Tokenization",
            placeholderText: [
                "Mineralex Group revolutionize mineral exploration and extraction through tokenized operations, enabling widespread investor participation and empowering local African communities. ",
                "By combining blockchain’s transparency with the tangible backing of real-world assets, Mineralex aims to create secure, accessible, and profitable mining investment opportunities for global investors.",
            ],
            accessLinkText: "Learn More",
            navigationLinks: [
                { text: "Dual-Token System Overview", link: "#tokenization_home" },
                { text: "Bridging Mining & Blockchain Technology", link: "#tokenization_slider" },
                { text: "Dual Token Strategy", link: "#tokenization_DualToken" },
                { text: "Utility Token Phrase", link: "#tokenization_utilityToken" },
                { text: "Quick Links", link: "#quick-links" },
            ],
            isMenuOpen: isOpen,
        },
        // {
        //     headerText: "Market Opportunity",
        //     placeholderText: [
        //         "Mineralex stands at the forefront of a highly lucrative market, with mineral reserves valued at billions of dollars. Gold reserves are estimated at $4 billion, while Coltan resources, critical for electronics and advanced technologies, are worth $6.3 billion. The rising global demand for Tantalum, Niobium, and Rare Earth. ",
        //         "Elements further amplifies the financial potential of these resources, positioning Mineralex as a leader in meeting the needs of a growing, technology-driven world.",
        //     ],
        //     accessLinkText: "Read More",
        //     navigationLinks: [
        //         { text: "Financial potential of Mineralex’s initiatives", link: "#market_home" },
        //         { text: "FutureSmart Mining™", link: "#market_FutureSmart" },
        //         { text: "Scope", link: "#market_Scope" },
        //         { text: "Quick Links", link: "#quick-links" },

        //     ],
        //     isMenuOpen: isOpen,
        // },
        {
            headerText: "Our Roadmap",
            placeholderText: ["See our progress and upcoming milestones.", "Join us on our journey forward."],
            accessLinkText: "Explore Roadmap",
            navigationLinks: [
                { text: "Provide a clear timeline of milestones and future plans", link: "#roadmap_home" },
                { text: "Future Plans", link: "#future_Plans" },
                { text: "Event and Reports", link: "#event_Reports" },
                { text: "Quick Links", link: "#quick-links" },
            ],
            isMenuOpen: isOpen,
        },

        {
            headerText: "Presale Token",
            placeholderText: [
                "Why Invest in the Mineralex Pre-Sale?",
                "The Mineralex pre-sale offers early investors a unique opportunity to acquire tokens at the best possible rates before the official public launch.",
                "By participating in this phase, you gain priority access to a revolutionary tokenized mining ecosystem, benefiting from lower entry costs and strategic positioning in a high-growth industry.",
                " This is not a public token sale.You are not purchasing tokens directly.Instead, you’re signing a SAFT agreement—a legal contract for the potential future allocation of tokens, contingent upon meeting all regulatory and legal requirements.",
            ],
            accessLinkText: "Go to Portal",
            navigationLinks: [
                { text: "Get token in advance", link: "#presale_home" },
                { text: "Secure Your Stake", link: "#stake" },
                { text: "Quick Links", link: "#quick-links" },
            ],
            isMenuOpen: isOpen,
        },
        {
            headerText: "Blogs & Updates",
            placeholderText: ["Stay informed with our latest blog posts.", "Read expert opinions and news."],
            accessLinkText: "Read Blogs",
            navigationLinks: [
                { text: "Get to know information", link: "#blog_home" },
                { text: "Latest Articles", link: "#latest_Articles" },
                { text: "News & Updates", link: "#update" },
                { text: "Quick Links", link: "#quick-links" },
            ],
            isMenuOpen: isOpen,
        },
        {
            headerText: "Contact Us",
            placeholderText: ["Get in touch with our support team.", "We’re here to help with any questions."],
            accessLinkText: "Contact Support",
            navigationLinks: [
                { text: "Get help from us", link: "#contact_Us_Home" },
                { text: "Send Message", link: "#send_Message" },
                { text: "Map", link: "#map" },
                { text: "Quick Links", link: "#quick-links" },
            ],
            isMenuOpen: isOpen,
        },
        {
            headerText: "Invest Now",
            placeholderText: [
                " This is not a public token sale.You are not purchasing tokens directly.Instead, you’re signing a SAFT agreement—a legal contract for the potential future allocation of tokens, contingent upon meeting all regulatory and legal requirements.",
            ],
            accessLinkText: "Review Now",
            navigationLinks: [
                { text: "Get review our strategy and performance", link: "#invest_Portal_Home" },
                { text: "Token Information", link: "#token_status" },
                { text: "Quick Links", link: "#quick-links" },
            ],
            isMenuOpen: isOpen,
        },
    ];

    return (
        <div className="flex h-screen overflow-x-hidden z-[9999]">
            <Sidebar
                isOpen={isOpen}
                onClose={() => setIsOpen(!isOpen)}
                menuItems={menuItems}
                contextsItems={contextsItems}
                isActive={isActive}
                setIsActive={setIsActive}
            />
        </div>
    );
};

const Sidebar: React.FC<{
    isOpen: boolean;
    onClose: () => void;
    menuItems: MenuItem[];
    contextsItems: ContextsItems[];
    isActive: number;
    setIsActive: React.Dispatch<React.SetStateAction<number>>;
}> = ({ isOpen, onClose, menuItems, contextsItems, isActive, setIsActive }) => {
    const navigate = useNavigate();
    const sidebarRef1 = useRef<HTMLDivElement>(null);
    const sidebarRef2 = useRef<HTMLDivElement>(null);
    const isMobile = window.innerWidth <= 640;
    const handleNavigation = (event: React.MouseEvent, link: string, index: number) => {
        event.preventDefault();
        navigate(link);
        setIsActive(index);
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (isMobile) {
            onClose();
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (sidebarRef1.current && !sidebarRef1.current.contains(event.target as Node))
                if (sidebarRef2.current && !sidebarRef2.current.contains(event.target as Node)) {
                    onClose();
                }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="w-full h-full">
            <div
                ref={sidebarRef1}
                className={`fixed top-0 left-0 h-full w-full sm:w-80 bg-[#253772] text-white transform ${isOpen ? "translate-x-0" : "-translate-x-full hidden"
                    } shadow-lg z-50 transition-all duration-500`}
            >
                <button onClick={onClose} className="flex items-center justify-end float-end p-2 gap-2 text-white font-semibold text-base hover:bg-red-500">
                    <IoCloseSharp className="text-yellow-400 text-xl font-bold" />
                    <div className="uppercase">Close</div>
                </button>

                <ul className="p-4 pt-12 font-montserrat">
                    {menuItems.map((item, index) => (
                        <li
                            key={index}
                            onClick={(e) => handleNavigation(e, item.link, index)}
                            className={`mt-4 ${isActive === index ? "translate-x-6 transition-transform duration-300 text-[#F8D835]" : "text-white"
                                }`}
                        >
                            <a href={item.link} className="w-3/4 flex justify-between items-center hover:text-[#3CCDB3]">
                                {item.text} <span>&gt;</span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>

            {contextsItems[isActive] && (
                <div ref={sidebarRef2} className="w-full">
                    <ContentArea
                        headerText={contextsItems[isActive].headerText}
                        placeholderText={contextsItems[isActive].placeholderText}
                        accessLinkText={contextsItems[isActive].accessLinkText}
                        navigationLinks={contextsItems[isActive].navigationLinks}
                        isMenuOpen={isOpen}
                    />
                </div>

            )}
        </div>
    );
};

const ContentArea: React.FC<{
    headerText: string;
    placeholderText: string[];
    accessLinkText: string;
    navigationLinks: NavLink[];
    isMenuOpen: boolean;
}> = ({ headerText, placeholderText, accessLinkText, navigationLinks, isMenuOpen }) => {
    return (
        <div className={`hidden fixed z-50 h-screen w-1/2 max-w-[600px] flex-1 bg-white font-montserrat p-6 py-16 transition-all duration-300 ${isMenuOpen ? "ml-80 sm:block" : "hidden"} overflow-y-auto`}>
            <h1 className="text-4xl font-normal font-bungeeinline text-[#253772] border-l-4 px-2 border-[#253772]">
                {headerText}
            </h1>

            {placeholderText.map((text, index) => (
                <p key={index} className="w-full text-black mt-4">{text}</p>
            ))}

            <a href="#" className="w-full flex justify-between pr-[30%] font-bold text-lg text-[#253772] py-4 inline-flex items-center border-b-[1px] px-2 border-[#253772]">
                {accessLinkText}
                <FaArrowRightLong className="flex-shrink-1" />
            </a>

            <ul className="w-full mt-6">
                {navigationLinks.map((link, index) => (
                    <li key={index} className="mt-2 flex flex-row justify-center items-center gap-1">
                        <a href={link.link} className="w-2/3 flex flex-row justify-between text-black hover:text-[#3CCDB3]">
                            <div>{link.text}</div>
                            <div className="flex flex-col justify-center items-center">
                                <FaArrowRightLong className="flex-shrink-0" />
                            </div>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default HamburgerMenuWindow;